import React from 'react'

import { Absolute } from '../helpers/Position'
import { useContrastColor } from '../theme/_hooks/colors'
import Hover, { Hidden } from '../helpers/Hover'
import Icon from '../shapes/Icon'
import Panel from '../structure/Panel'
import Text from './Text'

const getPositions = name => {
  switch (name) {
    case 'topLeft':
      return {
        panel: { bottom: 'calc(100% + 5px)', left: '-6px' },
        icon: { left: '4px', bottom: '-14px' },
        iconName: 'RiArrowDownSFill'
      }

    case 'topRight':
      return {
        panel: { bottom: 'calc(100% + 5px)', right: '-6px' },
        icon: { right: '4px', bottom: '-14px' },
        iconName: 'RiArrowDownSFill'
      }

    case 'bottomLeft':
      return {
        panel: { top: 'calc(100% + 5px)', left: '-6px' },
        icon: { left: '4px', top: '-11px' },
        iconName: 'RiArrowUpSFill'
      }

    case 'bottomRight':
      return {
        panel: { top: 'calc(100% + 5px)', right: '-6px' },
        icon: { right: '4px', top: '-11px' },
        iconName: 'RiArrowUpSFill'
      }

    case 'right':
      return {
        panel: { top: '-6px', right: 'calc(100% + 5px)' },
        icon: { top: '4px', right: '-11px' },
        iconName: 'RiArrowRightSFill'
      }

    default:
      return {
        panel: { top: '-6px', left: 'calc(100% + 5px)' },
        icon: { top: '4px', left: '-11px' },
        iconName: 'RiArrowLeftSFill'
      }
  }
}

const Tooltip = ({ children, label, content, position, bgColor, borderColor, ...props }) => {
  position = position || 'right'
  const contrastColor = useContrastColor(bgColor || 'white')
  const positions = getPositions(position)

  if (!label) return children

  return (
    <Hover position="relative" prefix="tooltip-">
      {children}
      <Hidden position="absolute" prefix="tooltip-" zIndex={1000} {...positions.panel}>
        <Absolute {...positions.icon}>
          <Icon name={positions.iconName} color={bgColor || 'light4'} size={1.2} />
        </Absolute>
        <Panel
          padding={0.2}
          radius={0.2}
          bgColor={bgColor || 'white'}
          borderColor={borderColor || 'light4'}
          minWidth={8}
          width="max-content"
          maxWidth={17.5}
        >
          {content || (
            <Text size="small" align="center" color={contrastColor} {...props}>
              {label}
            </Text>
          )}
        </Panel>
      </Hidden>
    </Hover>
  )
}

export default Tooltip
